import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import M from "materialize-css";
import Sound from "react-sound";
import cloneDeep from "lodash/cloneDeep";
import map from "lodash/map";

//component
import PlayList from "./PlayList/PlayList";
import TrackTitle from "./TrackTitle/TrackTitle";
import PlayerNavigation from "./PlayerNavigation/PlayerNavigation";

import PlayerActions from "../../../../store/ducks/player";
import PlayerControls from "./PlayerControls/PlayerControls";
import PlayerProgress from "./PlayerProgress/PlayerProgress";
import PlayerTimer from "./PlayerTimer/PlayerTimer";
import PlayerVolumeControl from "./PlayerVolumeControl/PlayerVolumeControl";
import ChannelTitle from "./ChannelTitle/ChannelTitle";

const HorizontalPlayer = (props) => {
  const {
    pauseTrack,
    playTrack,
    player,
    setPosition,
    volumePositionHandler,
    setMute,
    setEpisode,
    setPlaylist,
  } = props;
  // console.log('HorizontalPlayer ', props)
  const millisecondsToSeconds = ms => {
    return parseInt(ms / 1000, 10).toFixed(0);
  };

  const secondsToMilliseconds = seconds => {
    return parseInt(seconds * 1000, 10);
  };

  const [volume, setVolume] = useState(100);
  const [draggedItem, setDraggedItem] = useState({});
  const [draggedOverItem, setDraggedOvertem] = useState({});
  const [internalPosition, setInternalPosition] = useState(null);
  let playlistDropdownInstance = null;
  let volumeDropdownInstance = null;

  useEffect(() => {
    const playlistDropdownEl = document.querySelectorAll(".dropdown-trigger");
    const volumeDropdownEl = document.querySelectorAll(
      ".volume-dropdown-trigger"
    );
    
    return () => {
      if (playlistDropdownInstance) playlistDropdownInstance[0].destroy();
      if (volumeDropdownInstance) volumeDropdownInstance[0].destroy();

    };
  }, [
    internalPosition,
    playlistDropdownInstance,
    setPosition,
    volumeDropdownInstance
  ]);

  useEffect(() => {
    player.mute ? setVolume(0) : setVolume(player.volumePosition);
  }, [player.mute, player.volumePosition]);

  useEffect(() => {
    if (player.volumePosition) {
      setVolume(player.volumePosition);
    }
  }, [player.volumePosition]);

  useEffect(() => {
    setInternalPosition(secondsToMilliseconds(player.position));
  }, [player.position]);

  useEffect(() => {
    if (
      draggedItem &&
      Object.keys(draggedItem).length > 0 &&
      draggedOverItem &&
      Object.keys(draggedOverItem).length > 0
    ) {
      const playlistClone = map(player.playlist, cloneDeep);
      const draggedEpisodeIndex = playlistClone.findIndex(
        draggedEpisode => draggedEpisode.id === draggedOverItem.id
      );
      let draggedPlaylist = playlistClone.filter(
        item => item.id !== draggedItem.id
      );
      draggedPlaylist.splice(draggedEpisodeIndex, 0, draggedItem);

      // Mutation here
      setPlaylist(draggedPlaylist);
    }
  }, [draggedItem, draggedOverItem, player.playlist, setPlaylist]);

  const volumeHandler = volumeValue => {
    volumePositionHandler(volumeValue);
    setVolume(volumeValue);
  };

  const playerStopHandler = (positionValue, duration) => {
    // Mutation to save player.position
    setPosition(millisecondsToSeconds(positionValue));
  };

  const playerPositionHandler = progressPosition => {
    const progressTime = parseInt(
      progressPosition * secondsToMilliseconds(player.episode.duration),
      10
    );
    setPosition(millisecondsToSeconds(progressTime));
  };

  const playingHandler = (position, duration) => {
    setInternalPosition(position);
  };

  const playerProgressValue = () => {
    return (
      parseInt(
        internalPosition *
          (1000 / secondsToMilliseconds(player.episode.duration)),
        10
      ) || 0
    );
  };

  const newEpisodeHandler = newEpisode => {
    setEpisode(newEpisode);
    setPosition(0);
  };

  const playlistDragStartHandler = (e, episode) => {
    if (episode && Object.keys(episode).length > 0) {
      setDraggedItem(episode);
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/html", e.target.parentNode);
      e.dataTransfer.setDragImage(e.target.parentNode, 20, 20);
    }
  };

  const playlistDragEndHandler = () => {
    setDraggedItem({});
    setDraggedOvertem({});
  };

  const playlistDragOverHandler = (e, episode) => {
    e.preventDefault();
    if (episode && Object.keys(episode).length > 0) {
      setDraggedOvertem(episode);
    }
  };
  if(props.match && props.match.path.indexOf('episodes') > -1 && props.match.params.id && document.player.getCurrent() && document.player.getCurrent().id == props.match.params.id ){
    return <></>
  } else {
    return (
      <nav className="player">
        <div className="row">
          <div className="col s12">
            <div className="player-content">
              <figure className="player-thumbnail-wrapper hide-on-med-and-down">
                <img
                  src={player.episode.thumbnail}
                  width={30}
                  alt={player.episode.title}
                />
              </figure>
              <PlayerControls
                player={player}
                playTrack={playTrack}
                pauseTrack={pauseTrack}
                setEpisode={newEpisodeHandler}
                classes="hide-on-med-and-down"
              />
              <div className="player-navigation-wrapper">
                <div className="marquee-wrapper">
                  <TrackTitle title={player.episode.title} />
                  <ChannelTitle channelName={player.episode.channel.name} />
                </div>
                <div className="player-navigation">
                  <div className="player-track">
                    <PlayerProgress
                      progressHandler={playerPositionHandler}
                      progressValue={playerProgressValue()}
                    />
                    <PlayerTimer
                      position={internalPosition}
                      duration={secondsToMilliseconds(player.episode.duration)}
                    />
                  </div>
                </div>
              </div>
              <PlayerVolumeControl
                volumeHandler={volumeHandler}
                volume={volume}
                muteHandler={setMute}
                muteStatus={player.mute}
                classes="hide-on-med-and-down"
                dropDownTrigger="volumeDropdown"
              />
              <PlayerNavigation />
              <PlayList
                playlist={player.playlist}
                currentEpisode={player.episode}
                setEpisode={newEpisodeHandler}
                dragOverHandler={playlistDragOverHandler}
                dragEndHandler={playlistDragEndHandler}
                dragStartHandler={playlistDragStartHandler}
                classes="hide-on-med-and-down"
                dropDownTrigger="playlistDropdown"
              />
              <div className="show-on-medium-and-down hide-on-large-only">
                <div className="player-responsive-navigation">
                  <PlayerControls
                    player={player}
                    playTrack={playTrack}
                    pauseTrack={pauseTrack}
                    setEpisode={newEpisodeHandler}
                  />
                  <PlayerVolumeControl
                    volumeHandler={volumeHandler}
                    volume={volume}
                    muteHandler={setMute}
                    muteStatus={player.mute}
                    dropDownTrigger="volumeResponsiveDropdown"
                  />
                  <PlayList
                    playlist={player.playlist}
                    currentEpisode={player.episode}
                    setEpisode={newEpisodeHandler}
                    dragOverHandler={playlistDragOverHandler}
                    dragEndHandler={playlistDragEndHandler}
                    dragStartHandler={playlistDragStartHandler}
                    dropDownTrigger="playlistResponsiveDropdown"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    );

  }
};

const mapStateToProps = state => {
  return {
    player: state.player
  };
};
const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...PlayerActions }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HorizontalPlayer);
